import HeaderForForm from '@/components/HeaderForForm';
import * as Api from '@/api';
import { mapState } from 'vuex';
import MaskedInput from 'vue-masked-input';

import {
  phone,
  firstName,
  middleName,
  lastName } from '@/utils/input_validations';

const _setData = (dataState) => {
  return {
    ...{ firstName: dataState.firstName },
    ...{ lastName: dataState.lastName },
    ...{ middleName: dataState.middleName },
    ...{ phone: dataState.phone }
  };
};

export default {
  name: 'EditProfile',
  components: {
    HeaderForForm,
    MaskedInput
  },
  data() {
    return {
      userId: null,
      formFiler: {
        firstName: null,
        middleName: null,
        lastName: null,
        phone: null
      },
      defaultValueForm: {},
      isDataSave: false,
      fields: [
        {
          key: 'date',
          label: 'Дата добавления',
          sortable: true
        },
        {
          key: 'company',
          label: 'Правообладатель'
        },
        {
          key: 'dateFrom',
          label: 'Дата с'
        },
        {
          key: 'dateTo',
          label: 'Дата по'
        },
        {
          key: 'status',
          label: 'Статус'
        }
      ]
    };
  },
  validations() {
    return {
      formFiler: {
        phone,
        firstName,
        middleName,
        lastName
      }
    };
  },
  watch: {
    authUser() {
      this.formFiler = _setData(this.authUser);
    }
  },
  mounted() {
    this.formFiler = _setData(this.authUser);
    this.defaultValueForm = { ...this.formFiler };
  },
  computed: {
    ...mapState({
      authUser: state => state.authUser
    })
  },
  methods: {
    closeForm() {
      this.formFiler = {};

      this.$router.push({ path: '/profile' });
    },
    performFormAction() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      this.isDataSave = true;

      Api.editProfile({ data: this.formFiler })
        .then((response) => {
          if (response) {
            this.$toastr('success', 'Данные успешно обновлены.');
            this.$store.dispatch('getPersonalDetailsAuthUser');
            this.$router.push({ path: `/profile` });
            this.isDataSave = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$rollbar.warning(error);
          }
          this.$toastr('error', 'Данные не обновлены.', 'Ошибка');

          this.isDataSave = false;
        });
    }
  }
};
